var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProcessIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 46C35.7025 46 46 35.7025 46 23C46 10.2975 35.7025 0 23 0C10.2975 0 0 10.2975 0 23C0 35.7025 10.2975 46 23 46Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9999 16.3333C11.3186 16.3333 8.33325 19.3186 8.33325 22.9999C8.33325 26.6813 11.3186 29.6666 14.9999 29.6666H20.3333V26.9999H14.9999C12.7906 26.9999 10.9999 25.2093 10.9999 22.9999C10.9999 20.7906 12.7906 18.9999 14.9999 18.9999H20.3333V16.3333H14.9999ZM25.6666 16.3333V18.9999H30.9999C33.2092 18.9999 34.9999 20.7906 34.9999 22.9999C34.9999 25.2093 33.2092 26.9999 30.9999 26.9999H25.6666V29.6666H30.9999C34.6812 29.6666 37.6666 26.6813 37.6666 22.9999C37.6666 19.3186 34.6812 16.3333 30.9999 16.3333H25.6666ZM16.3333 21.6666V24.3333H29.6666V21.6666H16.3333Z",
    fill: "#313131"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcessIcon2);
export default __webpack_public_path__ + "static/media/processIcon-2.e62ea5bef63c918850206c9e92469174.svg";
export { ForwardRef as ReactComponent };